/* app/js/src/components/clipping-studio/video-preview/clipping-studio-video-preview.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  flex-grow: 1;
  width: 100%;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.video-container {
  width: 90%;
  height: 90%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-container .video-hidden {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  z-index: 0;
  pointer-events: none;
}
.video-container .video-thumbnail-capture {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}
.video-container .preview-canvas {
  position: relative;
  z-index: 1;
  display: block;
}
.video-container .gfx-iframe-container {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  pointer-events: none;
  opacity: 0;
}
.video-container .main-overlay-canvas {
  position: absolute;
  z-index: 2;
  pointer-events: none;
  display: block;
}
.video-container .main-overlay-canvas.main-overlay-canvas--interactive {
  pointer-events: auto;
}
.video-container .subtitles-canvas {
  position: absolute;
  z-index: 3;
  pointer-events: none;
  display: block;
}
.video-container .video-loading {
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(35, 47, 58);
}
.video-container .video-loading span {
  color: rgba(255, 255, 255, 0.5);
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
}
.video-container .no-video {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgb(35, 47, 58);
}
.video-container .no-video span {
  color: rgba(255, 255, 255, 0.5);
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
}
/*# sourceMappingURL=clipping-studio-video-preview.component.css.map */
